import { Routes, RouterModule } from '@angular/router';

//  Route for content layout with sidebar, navbar and footer
export const Full_ROUTES: Routes = [
  {
    path: 'dashboard',
    loadChildren: './dashboard/dashboard.module#DashboardModule'
  },
  {
    path: 'redirect/check',
    loadChildren: './redirect/redirect.module#RedirectModule'
  },
  {
    path: 'servizi/affiliazioni',
    loadChildren: './servizi/affiliazioni/affiliazioni.module#AffiliazioniModule'
  },
  {
    path: 'servizi/comitati',
    loadChildren: './servizi/comitati/comitati.module#ComitatiModule'
  },
  {
    path: 'servizi/gruppi',
    loadChildren: './servizi/gruppi/gruppi.module#GruppiModule'
  },
  {
    path: 'servizi/eventi',
    loadChildren: './servizi/eventi/eventi.module#EventiModule',
  },
  {
    path: 'servizi/gare',
    loadChildren: './servizi/gare/gare.module#GareModule',
  },
  {
    path: 'servizi/tesseramento',
    loadChildren: './servizi/tesseramento/tesseramento.module#TesseramentoModule'
  },
  {
    path: 'servizi/interno',
    loadChildren: './servizi/tesseramento/tesseramento.module#TesseramentoModule'
  },
  {
    path: 'servizi/tessere',
    loadChildren: './servizi/tessere/tessere.module#TessereModule'
  },
  {
    path: 'servizi/magazzino',
    loadChildren: './servizi/magazzino/magazzino.module#MagazzinoModule'
  },
  {
    path: 'servizi/formativa',
    loadChildren: './servizi/formativa/corsi.module#CorsiModule'
  },
  {
    path: 'servizi/didattica',
    loadChildren: './servizi/didattica/corsi.module#CorsiModule'
  },
  {
    path: 'servizi/conversioni',
    loadChildren: './servizi/conversioni/conversioni.module#ConversioniModule'
  },
  {
    path: 'albo/tecnici',
    loadChildren: './albi/tecnici/tecnici.module#TecniciModule'
  },
  {
    path: 'albo/formatori',
    loadChildren: './albi/formatori/formatori.module#FormatoriModule'
  },
  {
    path: 'contabilita',
    loadChildren: './contabilita/contabilita.module#ContabilitaModule'
  },
  {
    path: 'wallet',
    loadChildren: './wallet/wallet.module#WalletModule'
  },
  {
    path: 'project-admin',
    loadChildren: './project-admin/project.module#ProjectModule'
  },
  {
    path: 'project',
    loadChildren: './project/project.module#ProjectModule'
  },
  {
    path: 'walletadmin',
    loadChildren: './wallet-admin/wallet.module#WalletModule'
  },
  {
    path: 'discipline',
    loadChildren: './discipline/discipline.module#DisciplineModule'
  },
  {
    path: 'notifiche',
    loadChildren: './notifiche/notifiche.module#NotificheModule'
  },
  {
    path: 'elenco-notifiche',
    loadChildren: './elenco-notifiche/elenco-notifiche.module#ElencoNotificheModule'
  },
  {
    path: 'media',
    loadChildren: './media/media.module#MediaModule'
  },
  {
    path: 'utenti',
    loadChildren: './utenti/utenti.module#UtentiModule'
  },
  {
    path: 'servizi/disabili',
    loadChildren: './servizi/disabili/disabili.module#DisabiliModule'
  },
  {
    path: 'servizi/report',
    loadChildren: './servizi/report/report.module#ReportModule'
  },
  {
    path: 'voucher',
    loadChildren: './voucher/voucher.module#VoucherModule'
  },
  {
    path: 'assicurazione-animali',
    loadChildren: './assicurazione-animali/assicurazione-animali.module#AssicurazioneAnimaliModule'
  },
  {
    path: 'drivalia',
    loadChildren: './drivalia/drivalia.module#DrivaliaModule'
  },
  {
    path: 'impianti-extra',
    loadChildren: './impianti-extra/impianti-extra.module#ImpiantiExtraModule'
  },
  {
    path: 'changelog',
    loadChildren: './changelog/changelog.module#ChangeLogModule'
  },
  {
    path: 'full-layout',
    loadChildren: './pages/full-layout-page/full-pages.module#FullPagesModule'
  }
];



// WEBPACK FOOTER //
// ./src/app/shared/routes/full-layout.routes.ts